import env from '../../../config/env';
import * as types from '../../types/base-post.types';
import { errorGQLHandler } from '../../../helpers/helpers';
import NOTICIA_SE_LIGA from '../../../graphql/revista/queries/NoticiaSeLiga.gql';
import NOTICIAS_SE_LIGA from '../../../graphql/revista/queries/NoticiasSeLiga.gql';

export default {
  namespaced: true,
  state: {
    perPage: 5,
    carregando: true,
    data: {},
    seLiga: [],
  },
  getters: {
    seLiga: state => state.seLiga,
    carregando: state => state.carregando,
    postData: state => state.data,
  },
  mutations: {
    [types.SE_LIGA](state, payload) {
      state.seLiga = payload;
    },
    [types.POST](state, payload) {
      state.carregando = false;
      state.data = payload || {};
    },
  },
  actions: {
    async getSeLiga({ commit, state, rootGetters }, limit) {
      const paginate = limit || state.perPage;
      const uf = await rootGetters['user/uf'];
      const query = await env.apolloRevista.query({
        query: NOTICIAS_SE_LIGA,
        variables: {
          modulo: env.revista.modulo,
          canal: rootGetters['home/canal'],
          uf: [uf],
          paginate,
        },
        fetchPolicy: 'no-cache',
      });

      try {
        const { data } = query.data.noticias;
        commit(types.SE_LIGA, data);
      } catch (e) {
        errorGQLHandler(e);
      }
    },
    async getPost({ commit, state, rootGetters }, payload) {
      const ufs = await rootGetters['uf/ufs'];
      const ufId = ufs.filter(uf => uf.sigla === rootGetters['user/uf']).map(item => item.id);

      return new Promise((resolve, reject) => {
        state.data = {};
        state.carregando = true;
        setTimeout(() => {
          const uf = rootGetters['user/uf'];
          if (uf) {
            env.apolloRevista
              .query({
                query: NOTICIA_SE_LIGA,
                variables: {
                  modulo: env.revista.modulo,
                  canal: env.revista.canal,
                  slug: payload,
                  uf: [uf],
                  ufs_favoritos: ufId,
                },
                fetchPolicy: 'no-cache',
              })
              .then(
                ({ data: { noticias } }) => {
                  const [data] = noticias.data;
                  state.carregando = false;
                  commit(types.POST, data);
                  resolve(data);
                },
                err => {
                  errorGQLHandler(err);
                  reject(err);
                },
              );
          }
        }, 300);
      });
    },
  },
};
